import { useState } from "react";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";

export function useSlotPaymentLink() {
  const [paymentLinkData, setPaymentLinkData] = useState(null);

  const handleCreatePaymentLink = async (slotItem) => {
    try {
      const apiResult = await API({
        url: "/slotbooking/create-payment-link",
        method: "POST",
        responseType: "json",
        data: { slot_id: slotItem.slot_id },
      });
      if (apiResult.code === 200) {
        setPaymentLinkData(apiResult.data);
        // Toast("success", "Payment link created successfully");
      } else {
        Toast("error", apiResult.message || "Failed to create payment link");
      }
    } catch (error) {
      Toast("error", "Failed to create payment link");
    }
  };

  const closePaymentLink = () => setPaymentLinkData(null);

  return { paymentLinkData, handleCreatePaymentLink, closePaymentLink };
}

export function SlotPaymentLinkModal({ paymentLinkData, onClose }) {
  if (!paymentLinkData) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 p-6 flex flex-col gap-3"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold mb-0">Payment Link</h3>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <p className="mb-0 break-all">
          <span className="font-medium">Link ID:</span> {paymentLinkData.link_id}
        </p>
        <p className="mb-0 break-all">
          <span className="font-medium">Link URL:</span> {paymentLinkData.link_url}
        </p>
        <p className="mb-0">
          <span className="font-medium">CF Link ID:</span> {paymentLinkData.cf_link_id}
        </p>
        <div className="d-flex gap-2 mt-2">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.open(paymentLinkData.link_url, "_blank")}
          >
            Open Payment Link
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
